import React from 'react';
import { Avatar } from '@reverse-hr/design-system';

const Manager = ({ modifier = '', manager = {}, reversed = false }) => {
  return (
    <div
      className={`c-app-user ${modifier} ${
        reversed ? 'c-app-user--reversed' : ''
      }`}
    >
      <div className="c-app-user__avatar">
        <Avatar size={36} src={manager.avatarUrl} />
      </div>

      <div className="c-app-user__info">
        <p className="primary-txt">{`${manager.firstName} ${manager.lastName}`}</p>
        <p className="secondary-txt">{manager.jobTitle}</p>
      </div>
    </div>
  );
};

export default Manager;
